const axios = require('axios');

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
let token = document.getElementsByName('csrfmiddlewaretoken');

if (token && token.length > 0) {
    axios.defaults.headers.common['X-CSRFTOKEN'] = token[0].value;
}

export default axios;